/* eslint-disable */
(function (window, $) {
    "use strict";
    var dirtyApiUrl = "https://api.quickmedia.tv",
        apiUrl =
            dirtyApiUrl.indexOf("http:") === 0 && window.location.protocol === "https:"
                ? "https:" + dirtyApiUrl.substring(5)
                : dirtyApiUrl,
        head = document.getElementsByTagName("head")[0] || document.documentElement;
    function prepareSmart(embedId, assetId, customerToken, ip, stream, embedQuery, settings) {
        var player = createPlayer(embedId, ip, settings);
        player.videoInfos[0] = {
            assetId: assetId,
            customerToken: customerToken,
            stream: stream,
            lazyLoading: false,
        };
        loadPlayerToObject(player, buildPlayerEmbedUrl(player, 0, embedQuery));
        return player;
    }
    function createPlayer(embedId, ip, settings) {
        settings = settings || {};
        settings["userHostAddress"] = settings["userHostAddress"] || ip;
        writeSettingsDefaults(settings);
        var player = { embedId: embedId, settings: settings, videoInfos: [] };
        writePlayerDefaults(player);
        return player;
    }
    function writeSettingsDefaults(settings) {
        if (!("embedPolyfill" in settings)) {
            settings.embedPolyfill = true;
        }
    }
    function writePlayerDefaults(player) {
        if (!("embedId" in player) && !("embed" in player)) {
            player.embed = document.getElementsByTagName("body")[0];
        }
    }
    function loadPlayerToObject(player, url) {
        return crossDomainAjax(url, function (data) {
            window.loadPlayerWithData(data, player);
        });
    }
    function buildPlayerEmbedUrl(player, index, embedQuery) {
        var browserLang = (navigator.languages || [navigator.language || navigator.userLanguage])[0],
            language = player.settings["language"] || browserLang,
            region = player.settings["region"],
            token = createToken(player.videoInfos[index].customerToken, language, region),
            url =
                apiUrl +
                "/json/player-embed?assetId=" +
                player.videoInfos[index].assetId +
                "&token=" +
                token +
                (player.videoInfos[index].stream !== undefined
                    ? "&streamGroup=" + player.videoInfos[index].stream
                    : "");
        url += getEmbedQueryPart("userHostAddress", player.settings);
        url += getEmbedQueryPart("autoplay", player.settings);
        url += getEmbedQueryPart("stretching", player.settings);
        url += getEmbedQueryPart("preload", player.settings);
        if (embedQuery) {
            url += "&" + embedQuery;
        }
        return url;
    }
    function createToken(customerToken, language, region) {
        return customerToken + ";;;1.0;;" + (language || "") + ";" + (region || "") + ";";
    }
    function getEmbedQueryPart(key, dictionary, defaultValue) {
        var part = "";
        if (typeof dictionary === "object" && key in dictionary) {
            part = "&" + key + "=" + encodeURIComponent(dictionary[key]);
        } else if (defaultValue) {
            part = "&" + key + "=" + encodeURIComponent(defaultValue);
        }
        return part;
    }
    function crossDomainAjax(url, successCallback) {
        $.support.cors = true;
        var deferred = $.Deferred();
        if ("XDomainRequest" in window && window.XDomainRequest !== null) {
            var xdr = new XDomainRequest();
            xdr.open("get", url);
            xdr.onload = function () {
                var dom = new ActiveXObject("Microsoft.XMLDOM"),
                    JSON = $.parseJSON(xdr.responseText);
                dom.async = false;
                if (JSON === null || typeof JSON === "undefined") {
                    JSON = $.parseJSON(data.firstChild.textContent);
                }
                deferred.resolve(JSON);
                successCallback(JSON);
            };
            xdr.onerror = function () {
                deferred.reject(arguments);
            };
            xdr.send();
        } else if (
            navigator.userAgent.indexOf("MSIE") !== -1 &&
            parseInt(navigator.userAgent.match(/MSIE ([\d.]+)/)[1], 10) < 8
        ) {
            return false;
        } else {
            $.ajax({
                url: url,
                cache: false,
                dataType: "json",
                type: "GET",
                success: function (data, success) {
                    deferred.resolve(data);
                    successCallback(data);
                },
                error: function () {
                    deferred.reject(arguments);
                },
            });
        }
        return deferred.promise();
    }
    function loadPlayerWithData(data, player) {
        player = player || {};
        writePlayerDefaults(player);
        player.settings = player.settings || {};
        writeSettingsDefaults(player.settings);
        for (var key in data.cssFiles) {
            var css = data.cssFiles[key];
            if (document.getElementsByName(css).length === 0) {
                var el = document.createElement("link");
                el.setAttribute("href", css);
                el.setAttribute("name", css);
                el.setAttribute("rel", "stylesheet");
                head.appendChild(el);
            }
        }
        if (data.jsFiles.length > 0) {
            if (data.type >= 10) {
                onLoadedScripts(data, player);
                window.setTimeout(scriptLoader.bind(null, data.jsFiles));
            } else {
                var lastScriptElement = scriptLoader(data.jsFiles);
                if (lastScriptElement) {
                    lastScriptElement.onload = function () {
                        onLoadedScripts(data, player);
                    };
                } else {
                    onLoadedScripts(data, player);
                }
            }
        } else {
            onLoadedScripts(data, player);
        }

        return player;
    }
    function onLoadedScripts(data, player) {
        if (player.settings.embedPolyfill && data.type >= 10) {
            var fncToWrap = window["onPlayerInitialized"];
            if (fncToWrap !== onPlayerInitialized_polyfilled) {
                window["onPlayerInitialized_wrapped"] = fncToWrap;
                window.onPlayerInitialized = onPlayerInitialized_polyfilled;
            }
        }
        var smartObj = player.embed || document.getElementById(player.embedId);
        smartObj.innerHTML = data.code
            ? data.code.replace(
                  "data-embed-javascript-placeholder",
                  player.settings["hidden"] ? 'data-main-panel-render-css-class-name="player--hidden"' : ""
              )
            : "";
        var re = /<script\b[^>]*>([\s\S]*?)<\/script>/gm;
        var match, el;
        while ((match = re.exec(data.code))) {
            el = document.createElement("script");
            el.text = match[1];
            head.appendChild(el);
        }
        el = document.createElement("script");
        el.text = data.script
            .replace(/<script>/g, "")
            .replace(/<\/script>/g, "")
            .replace(/<script type="text\/javascript">/g, "");
        var lastQMPlayerId = window["lastQMPlayerId"],
            minLogLevel = player.settings["minLogLevel"];
        if (data.type == 1 && minLogLevel) {
            var logFlashVars =
                'log_enabled: "true", log_level: "' +
                minLogLevel +
                '", log_appenders: "trace,js", ' +
                'log_appender_trace: "TraceAppender", log_appender_trace_format: "%25date %25level [%25class] - %25message", log_appender_trace_level: "' +
                minLogLevel +
                '", ' +
                'log_appender_js: "BufferedJavaScriptAppender", log_appender_js_function: "log", log_appender_js_level: "' +
                minLogLevel +
                '", log_appender_js_filter: "vuplayer", ';
            el.text = el.text.replace("var flashvars = {", "var flashvars = {" + logFlashVars);
        } else if (data.type >= 10 && lastQMPlayerId) {
            var target = document.getElementById(lastQMPlayerId);
            setDataAttribute(target, player.settings, "plugins", "plugins");
            setDataAttribute(target, player.settings, "embed-key", "embedKey");
            setDataAttribute(target, player.settings, "player-visibilities", "playerVisibilities");
            setDataAttribute(target, player.settings, "get-configurations-url", "getConfigurationsUrl");
            setDataAttribute(target, player.settings, "get-localizations-url", "getLocalizationsUrl");
            setDataAttribute(target, player.settings, "lang", "lang");
            setDataAttribute(target, player.settings, "min-log-level", "minLogLevel");
        }
        head.appendChild(el);
        if (typeof window[data.load] !== "undefined") {
            player.playerObject = window[data.load]();
            player.resize = function (width, height) {
                if (width === undefined || height === undefined) {
                    var $embed = $(this.embed || "#" + this.embedId);
                    height = $embed.height();
                    width = $embed.width();
                }
                if (player.playerObject && "setSize" in player.playerObject) player.playerObject.setSize(width, height);
            };
            if (player.playerObject && "setSize" in player.playerObject) {
                var $embed = $(player.embed || "#" + player.embedId);
                player.playerObject.setSize($embed.width(), $embed.height());
            }
        }
    }
    function onPlayerInitialized_polyfilled(id, data) {
        var playerPolyfill = createPlayerEmbedPolyfill(data, this),
            el = document.getElementById(id);
        el["content"] = { vuPlayer: playerPolyfill };
        this.videoElement.addEventListener("play", playerPolyfill.onVideoStarted.bind(playerPolyfill));
        this.videoElement.addEventListener("playing", playerPolyfill.onVideoPlaying.bind(playerPolyfill));
        this.videoElement.addEventListener("paused", playerPolyfill.onVideoPaused.bind(playerPolyfill));
        this.videoElement.addEventListener("ended", playerPolyfill.onVideoFinished.bind(playerPolyfill));
        if (window["onPlayerInitialized_wrapped"]) {
            window.onPlayerInitialized_wrapped.apply(playerPolyfill, arguments);
        }
        playerPolyfill.onPlaylistLoaded.apply(playerPolyfill, arguments);
    }
    function setDataAttribute(target, obj, dataAttributeName, objPropertyName) {
        var objValue = obj[objPropertyName];
        if (objValue) {
            target.setAttribute("data-" + dataAttributeName, objValue);
        }
    }
    function createPlayerEmbedPolyfill(data, instance) {
        return {
            data: data,
            instance: instance,
            listenersByEventType: [],
            addPlaybackEventListener: function (eventType, listener) {
                eventType = eventType || "*";
                var v = this.listenersByEventType[eventType];
                if (!v) {
                    v = [];
                    this.listenersByEventType[eventType] = v;
                }
                v.push(listener);
            },
            removePlaybackEventListener: function (eventType, listener) {
                eventType = eventType || "*";
                var v = this.listenersByEventType[eventType];
                if (v) {
                    var index = -1;
                    for (var i = 0; i < v.length; i++) {
                        if (v[i] === listener) {
                            index = i;
                            break;
                        }
                    }
                    if (index >= 0) v.splice(index, 1);
                }
            },
            sendEvent: function (eventName) {
                this.callFunctions(eventName, eventName);
                this.callFunctions("*", eventName);
            },
            callFunctions: function (type, eventName) {
                var v = this.listenersByEventType[type];
                if (v) {
                    for (var i = 0; i < v.length; i++) {
                        try {
                            var arr = v[i].split(".");
                            var func = window[arr[0]];
                            for (var j = 1; j < arr.length; j++) {
                                if (func) func = func[arr[j]];
                            }
                            if (func) {
                                var event = {
                                    target: this.instance.uniqueId,
                                    type: eventName,
                                    context: null,
                                };
                                func.call(this, event);
                            }
                        } catch (e) {}
                    }
                }
            },
            onPlaylistLoaded: function () {
                this.sendEvent("PlaylistLoaded");
            },
            onVideoStarted: function () {
                this.sendEvent("VideoStarted");
            },
            onVideoPlaying: function () {
                this.sendEvent("VideoPlaying");
            },
            onVideoPaused: function () {
                this.sendEvent("VideoPaused");
            },
            onVideoFinished: function () {
                this.sendEvent("VideoFinished");
            },
            setOptions: function () {
                var arr = Array.prototype.slice.call(arguments);
                for (var i = 0; i < arr.length; i++) {
                    var pair = arr[i],
                        pos = pair.indexOf("=");
                    if (pos > 0) {
                        var key = pair.substr(0, pos).trim(),
                            value = pair.substr(1 + pos).trim();
                        if (key === "e") key = "binaryOptions";
                        if (key === "AutoPlay") value = stringToBoolean(value || "");
                        this.data[key] = value;
                    }
                }
            },
            setOption: function (name, value, itemIdentifier) {
                this.data[name] = value;
            },
            play: function () {
                this.triggerCommand("play");
            },
            pause: function () {
                this.triggerCommand("pause");
            },
            stop: function () {
                this.triggerCommand("stop");
            },
            seek: function (time) {
                this.triggerCommand("accurateSeek", time);
            },
            currentTime: (function (instance) {
                return function () {
                    return instance.videoElement.currentTime;
                };
            })(instance),
            state: (function (instance) {
                return function () {
                    return instance.embedElement.firstChild.className;
                };
            })(instance),
            triggerCommand: (function (instance) {
                return function (commandName, value) {
                    var triggered = instance.triggerCommand && instance.triggerCommand(commandName, value);
                    if (!triggered) {
                        console.warn("Failed to trigger " + commandName + " event");
                    }
                };
            })(instance),
            isTriggerCommandSupported: (function (instance) {
                return function () {
                    return !!instance.triggerCommand;
                };
            })(instance),
        };
    }
    function stringToBoolean(string) {
        switch (string.toLowerCase().trim()) {
            case "true":
            case "yes":
            case "1":
                return true;
            case "false":
            case "no":
            case "0":
                return false;
            default:
                return null;
        }
    }
    function scriptLoader(r) {
        var allScriptTags = document.getElementsByTagName("script");
        for (var i = 0; i < r.length; i++) {
            var src = r[i],
                srcPos = src.indexOf(dynamicJsPlayer) > 0 ? 1 : src.indexOf(dynamicSwfPlayer) ? 2 : 0;
            for (var j = 0; j < allScriptTags.length; j++) {
                var scriptTag = allScriptTags[j];
                if (
                    scriptTag.src &&
                    (scriptTag.src === src || (srcPos && scriptTag.src.indexOf(dynamicPlayers[srcPos - 1]) > 0))
                ) {
                    r.splice(i, 1);
                    break;
                }
            }
        }
        var e = document,
            t = "script";
        function n() {
            for (; d[0] && "loaded" === d[0][f]; ) (c = d.shift()), (c[o] = !i.parentNode.insertBefore(c, i));
        }
        var a;
        for (var s, c, d = [], k = e.scripts[0], o = "onreadystatechange", f = "readyState"; (s = r.shift()); )
            (a = e.createElement(t)),
                "async" in k
                    ? ((a.async = !1), e.head.appendChild(a))
                    : k[f]
                    ? (d.push(a), (a[o] = n))
                    : e.write("<" + t + ' src="' + s + '" defer></' + t + ">"),
                (a.src = s);
        return a;
    }
    var dynamicJsPlayer = "/player.min.js",
        dynamicSwfPlayer = "/player.min.swf",
        dynamicPlayers = [dynamicJsPlayer, dynamicSwfPlayer];
    window["prepareSmart"] = prepareSmart;
    window["createToken"] = createToken;
    window["buildPlayerEmbedUrl"] = buildPlayerEmbedUrl;
    window["loadPlayerToObject"] = loadPlayerToObject;
    window["loadPlayerWithData"] = loadPlayerWithData;
})(window, undefined);
